import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './vuetify'
import './analytics'

Vue.config.productionTip = false
Vue.mixin({
  data() {
    return {
      get trial() {
        return window.location.hostname.match("trial")
      }
    }
  }
})

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')

